function parseBusinessPhones(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value !== 'string') return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function getBusinessCardRows(contact = {}) {
  const rows = [];
  const add = (key, label, value, href) => {
    if (!value) return;
    rows.push({ key, label, value, ...(href ? { href } : {}) });
  };

  add('department', 'Abteilung', contact.department);
  add('position', 'Position', contact.job_title);

  const phones = [contact.mobile_phone, ...parseBusinessPhones(contact.business_phones)]
    .filter(Boolean)
    .filter((phone, index, all) => all.indexOf(phone) === index);
  add('phone', 'Telefon', phones.join(' | '));

  const email = contact.email && !contact.email.endsWith('@mailbox-contact.local')
    ? contact.email
    : '';
  add('email', 'E-Mail', email);

  const website = contact.branding?.website;
  try {
    add('website', 'Web', new URL(website).hostname.replace(/^www\./, ''), website);
  } catch {
    // Invalid or missing branding URL: omit the row.
  }

  return rows;
}
